import {
    ReactNode,
    createContext,
    useContext,
    useEffect,
    useState
} from 'react';
import { getFeatures } from 'api/features';
import { FEATURES } from 'domain/features';

const FeaturesContext = createContext({});

type ContextType = {
    features: string[];
};

type Props = {
    children: ReactNode;
};
const FeaturesProvider = ({ children }: Props) => {
    const [features, setFeatures] = useState<string[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getFeatures()
            .then(setFeatures)
            .finally(() => setLoading(false));
    }, []);

    return (
        <FeaturesContext.Provider value={{ features }}>
            {!loading && children}
        </FeaturesContext.Provider>
    );
};

type FeatureTypes = typeof FEATURES;
const useFeature = () => {
    const context = useContext(FeaturesContext) as ContextType;

    if (!context) {
        throw new Error('Features context not in place!');
    }

    const hasFeature = (feature: FeatureTypes[keyof FeatureTypes]) =>
        context.features.includes(feature);

    return { hasFeature };
};

export { FeaturesContext, FeaturesProvider, useFeature };
